import axios from 'axios'
import { clearSignupGates, switchAuthToken } from '@/setup/SetupAxios'

const COMPANY_SWITCH_FALLBACK_MESSAGE = 'Could not open this search in its company.'

interface CompanySwitchErrorResponse {
    message?: unknown
}

/** Keep Axios response-shape knowledge in the service layer rather than the page/handoff hook. */
export const browserTabCompanySwitchErrorMessage = (error: unknown): string => {
    if (!axios.isAxiosError<CompanySwitchErrorResponse>(error)) return COMPANY_SWITCH_FALLBACK_MESSAGE
    const message = error.response?.data?.message
    return typeof message === 'string' && message.trim() ? message : COMPANY_SWITCH_FALLBACK_MESSAGE
}

/**
 * Mint a company token for a detached browser tab without changing the user's server-side default company.
 * The endpoint's `tokenOnly` mode exists for isolated clients: omitting it updates activeApplicationId and
 * unexpectedly changes where future logins, the extension, and mobile sessions land.
 */
export const switchBrowserTabCompany = async (applicationId: string, signal: AbortSignal): Promise<void> => {
    const response = await axios.post<{ success: boolean; data: { token: string } }>('/organizations/switch', { applicationId, tokenOnly: true }, { signal })
    const token = response.data?.data?.token
    if (!response.data?.success || !token) throw new Error('The company session could not be opened.')

    // Match every established company-switch entry point: establish the target-only session, then clear
    // browser-wide onboarding gates before the hard navigation rebuilds the application state.
    switchAuthToken(token)
    clearSignupGates()
}
